import { cn } from "@babybjorn/ui";
import type { FC, FormHTMLAttributes, PropsWithChildren } from "react";
import Button from "../../Button";
import * as s from "./PillGroup.module.scss";

type PillGroupProps = PropsWithChildren<
	FormHTMLAttributes<HTMLFormElement> & {
		label?: string;
		priceModule?: boolean;
		openMaterialModal?: () => void;
	}
>;

const PillGroup: FC<PillGroupProps> = ({
	label,
	priceModule,
	children,
	openMaterialModal,
	...rest
}) => {
	return (
		<form {...rest}>
			<fieldset
				className={cn(s.container, { [s.priceModuleStyle]: priceModule })}
			>
				<div className={s.labelContainer}>
					{label && <label className={cn(s.label)}>{label}:</label>}
					{priceModule && openMaterialModal && (
						<Button
							buttonType="icon"
							variant="noBg"
							icon="question"
							className={s.question}
							onClick={openMaterialModal}
							aria-label={label}
						/>
					)}
				</div>
				<div className={cn(s.pillContainer)}>{children}</div>
			</fieldset>
		</form>
	);
};

export default PillGroup;
